import { APIModel } from './api-model.model'
import { APIPermission } from './permission.model'

export class APIRole extends APIModel {
    roleId: number;
    roleName: string;
    roleEnabled: number;
    active?: boolean;
    permissions?: APIPermission[];

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        roleId: number;
        roleName: string;
        roleEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.roleId = params.roleId
        this.roleName = params.roleName
        this.roleEnabled = params.roleEnabled ? 1 : 0
    }
}
